import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { LoadScript } from "@react-google-maps/api";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import App from './App';
import AddShop from './components/MainContent/AddShop';

const theme = createTheme({
    palette: {
        primary: { main: '#d67052', contrastText: '#FFFFFF' },
        secondary: { main: '#4a7aa5' },
        background: { default: '#fdfaf4', paper: '#f4ece0' },
        text: { primary: '#2a2418', secondary: '#7a6f5c' },
        divider: '#ebe2d0',
    },
    typography: {
        fontFamily: '"Noto Sans JP", "Hiragino Sans", "Hiragino Kaku Gothic ProN", Meiryo, sans-serif',
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: { borderRadius: 10, textTransform: 'none', fontWeight: 600 },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                html: { height: '100%' },
                body: { height: '100%', backgroundColor: '#fdfaf4', margin: 0 },
                '#root': { height: '100%', display: 'flex', flexDirection: 'column' },
            },
        },
    },
});

const globalCss = {
    ':root': {
        '--paper': '#fdfaf4',
        '--surface': '#f4ece0',
        '--surface-2': '#f7f1e6',
        '--hero': '#fcecd9',
        '--ink': '#2a2418',
        '--muted': '#7a6f5c',
        '--muted-2': '#d4cab8',
        '--line': '#ebe2d0',
        '--accent': '#d67052',
        '--accent-2': '#4a7aa5',
        '--font-display': "'Zen Kaku Gothic New', 'Noto Sans JP', sans-serif",
    },
    '*': { boxSizing: 'border-box' },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles styles={globalCss} />
        <Router>
            <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_API}>
                <Routes>
                    <Route path={"/"} element={<App />} />
                    <Route path={"/addshop"} element={<AddShop />} />
                </Routes>
            </LoadScript>
        </Router>
    </ThemeProvider>
);
